import { Component, Inject, Input, OnInit } from 'ng-metadata/core';
import { PrimolyticsService } from '../../../analytics/primolytics.service';
import { PermalinkService } from '../permalinkAction/permalink.service';
import { ShareService } from './share.service';

const isEqual = require('lodash/isEqual');


@Component({
    selector: 'prm-share',
    templateUrl: 'components/search/actions/shareAction/share.html',
})

export class PrmShare implements OnInit {
    @Input() public selectedIds: Object;
    @Input() private item: Object;
    private popupParams: string = `location=0,menubar=0,toolbar=0,personalbar=0,status=0,scrollbars=1,resizable=1`;

    public shareIconNamesMap = {
        'WhatsApp': 'whatsApp', 'Facebook': 'facebook', 'Twitter': 'twitter', 'LinkedIn': 'linkedIn'
    };
    public shareLabelNamesMap;
    public _shareIconList: string[] = [];

    constructor(private permalinkService: PermalinkService,
        @Inject('actionIcons') private actionIcons: Object,
        @Inject('$window') private $window: ng.IWindowService,
        @Inject('$location') private $location: ng.ILocationService,
        private primolyticsService: PrimolyticsService,
        private shareService: ShareService) {
    }
    ngOnInit() {
        this.shareLabelNamesMap = {
            'WhatsApp': 'shareWhatsApp',
            'Facebook': 'shareFacebook',
            'Twitter': 'shareTwitter',
            'LinkedIn': 'shareLinkedIn'
        };
    }

    private openShareDialog(item) {
        let permalink = this.permalinkService.shortPermalink;
        let url = this.changeTarget(permalink, item);
        this.openPopupShare(url, item);
    }

    /** Calculate popup window size */
    private popupSize() {
        const screen = this.$window.screen;
        const sw = screen.availWidth || 1024,
            sh = screen.availHeight || 700,
            pw = Math.min(600, sw - 40),
            ph = Math.min(600, sh - 40),
            px = Math.floor((sw - pw) / 2),
            py = Math.floor((sh - ph) / 2);

        return `width=${pw},height=${ph},left=${px},top=${py}`;
    }

    private openPopupShare(url: string, item): void {
        const popup = this.$window.open(url,
            this.popupParams,
            this.popupSize());
        if (popup) popup.focus();
    }

    private changeTarget(urlPermalink, item) {
        let currentService = this.shareService.shareServices.filter(e => e.key == item)[0];
        let currentServiceUrl = currentService.value;
        currentServiceUrl = currentServiceUrl.replace('URL_PLACEHOLDER', urlPermalink);
        return currentServiceUrl;
    }

    get shareIconList() {
        return this.shareService.requiredIconsList;
    }

    private keyDownSupport(e, item) {
        if (e.keyCode === 13) {
            this.openShareDialog(item);
            this.setAndRunOperationBeacon(item);
        }
    }

    private runBeacon(operation) {
        this.primolyticsService.doBeaconReport({
            'p': 'sendTo',
            'op': operation
        }, this.primolyticsService.getTimestamp());
    }

    public setAndRunOperationBeacon(button) {
        let operation = "";
        if (isEqual(button, "Facebook")){
            operation = "shareFacebook";
        }
        else if (isEqual(button, "Twitter")){
            operation = "shareTwitter";
        }
        else if (isEqual(button, "LinkedIn")){
            operation = "shareLinkedin";
        }
        else if (isEqual(button, "WhatsApp")){
            operation = "shareWhatsapp";
        }

        this.runBeacon(operation);     
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/shareAction/share.directive.ts